module.exports = __webpack_public_path__ + "img/vote-2.ee3d3375.png";